import React from 'react';

import {
  ClubCurrencySimpleIcon,
  WebCoinIcon,
} from '@wwe-portal/ui/components/icons';

export enum OfferTypeEnum {
  Standard = 'Standard',
  AlternativeCurrency = 'AlternativeCurrency',
}
export enum AlternativeCostIDEnum {
  WebCoins = 'WebCoins',
  ClubCoins = 'ClubCoin',
}

const validAlternativeCostIDs: string[] = Object.values(AlternativeCostIDEnum);
const isAlternativeCostID = (value: string): value is AlternativeCostIDEnum => {
  return validAlternativeCostIDs.includes(value);
};
export interface CurrencyIconProps {
  offerType: OfferTypeEnum | undefined;
  alternativeCostID: string | undefined;
  style?: React.CSSProperties;
  iconProps?: React.ComponentPropsWithoutRef<'svg'>;
}

const iconComponentMap: Record<AlternativeCostIDEnum, React.FC> = {
  [AlternativeCostIDEnum.ClubCoins]: ClubCurrencySimpleIcon,
  [AlternativeCostIDEnum.WebCoins]: WebCoinIcon,
};

export function CurrencyIcon({
  offerType,
  alternativeCostID,
  style,
  iconProps,
}: CurrencyIconProps) {
  if (offerType === OfferTypeEnum.Standard)
    return (
      <svg
        className="h-[18px] w-[18px]"
        fill="none"
        style={style}
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...iconProps}
      >
        <path
          d="M9 16.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm-2.625-6V12H8.25v1.5h1.5V12h.75a1.873 1.873 0 100-3.75h-3a.375.375 0 010-.75h4.125V6H9.75V4.5h-1.5V6H7.5a1.876 1.876 0 000 3.75h3a.375.375 0 010 .75H6.375z"
          fill="currentColor"
        />
      </svg>
    );

  if (
    offerType === OfferTypeEnum.AlternativeCurrency &&
    alternativeCostID != null &&
    isAlternativeCostID(alternativeCostID)
  ) {
    const Component = iconComponentMap[alternativeCostID];
    return <Component {...iconProps} />;
  }
  return null;
}
